// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__D0S1G {
  display: flex;
  justify-content: center;
  align-items: center; }
  .styles_container__D0S1G > div:first-child {
    position: absolute;
    top: 0rem; }

.styles_card__tNEzR {
  max-height: 36vh;
  width: 54vw;
  padding: 1rem; }
  .styles_card__tNEzR button {
    margin-top: 1rem; }
`, "",{"version":3,"sources":["webpack://./src/modules/auth/components/screens/Register/styles.module.scss"],"names":[],"mappings":"AAAA;EACI,aAAa;EACb,uBAAuB;EACvB,mBAAmB,EAAA;EAHvB;IAKQ,kBAAkB;IAClB,SAAS,EAAA;;AAIjB;EACI,gBAAgB;EAChB,WAAW;EACX,aAAa,EAAA;EAHjB;IAKQ,gBAAgB,EAAA","sourcesContent":[".container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    & > div:first-child {\n        position: absolute;\n        top: 0rem;\n    }\n}\n\n.card {\n    max-height: 36vh;\n    width: 54vw;\n    padding: 1rem;\n    button {\n        margin-top: 1rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__D0S1G`,
	"card": `styles_card__tNEzR`
};
export default ___CSS_LOADER_EXPORT___;
